import script from "./flow-record-popover-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./flow-record-popover-detail.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__